
import { ATTRIBUTES_VALIDATION_STATE } from "fe2/Components/UIKit/ClanCreate/Constants";
import { clanNameTag } from "./ReducerCreators";
import { Action } from "../../types/Action";
import { CREATE_CLAN, HIDE_CLAN_RULES_DIALOG, SET_CLAN_NAME, SET_CLAN_NAME_PROGRESS, SET_CLAN_TAG, SET_CLAN_TAG_PROGRESS, SHOW_CLAN_RULES_DIALOG } from "../Actions/ActionCreate";
import { START_CREATION_CLAN, ERROR_CREATION_CLAN, SET_INITIAL_STATE_CREATION_CLAN, UPDATE_CREATION_CLAN_FIELD_VALUE, START_CHECK_AVAILABILITY_CLAN_CREATION, FINISH_CHECK_AVAILABILITY_CLAN_CREATION } from "../Actions/ActionClanCreate";

export type State = {
  isProcessing: boolean;
  clanTag: string;
  clanTagError: string | null;
  isClanTagValidating: boolean;
  clanName: string;
  clanNameError: string | null;
  isClanNameValidating: boolean;
  isDisabled: boolean;
  isDiscount: boolean;
  isClanRulesDialogVisible: boolean;
  needGoldCreate: number | null;
};

let initialState: State = {
  isProcessing: false,
  clanTag: '',
  clanTagError: null,
  isClanTagValidating: false,
  clanName: '',
  clanNameError: null,
  isClanNameValidating: false,
  isDisabled: false,
  isDiscount: false,
  isClanRulesDialogVisible: false,
  needGoldCreate: 300
};

export type IReducerCreate = (state: State, action: Action) => State;
export const ReducerCreate = (state: State = initialState, action: Action): State => {
  switch (action.type) {

    case SHOW_CLAN_RULES_DIALOG:
      {
        return {
          ...state,
          isClanRulesDialogVisible: true
        };
      }
    case HIDE_CLAN_RULES_DIALOG:
      {
        return {
          ...state,
          isClanRulesDialogVisible: false
        };
      }
    case CREATE_CLAN:
      {
        return {
          ...state
        };
      }
    case SET_CLAN_NAME_PROGRESS:
      {
        const disabled = action.payload.inProgress ? { isDisabled: true } : {};
        return {
          ...state,
          isClanNameValidating: action.payload.inProgress,
          ...disabled
        };
      }
    case SET_CLAN_TAG_PROGRESS:
      {
        const disabled = action.payload.inProgress ? { isDisabled: true } : {};
        return {
          ...state,
          isClanTagValidating: action.payload.inProgress,
          ...disabled
        };
      }
    case SET_CLAN_TAG:
      {
        return {
          ...state,
          clanTag: action.payload.tag,
          clanTagError: action.payload.error,
          isDisabled: action.payload.error ? true : false
        };
      }
    case SET_CLAN_NAME:
      {
        return {
          ...state,
          clanName: action.payload.name,
          clanNameError: action.payload.error,
          isDisabled: action.payload.error ? true : false
        };
      }
    default:
      return state;

  }
};

const clanCreateInitialState = {
  tag: {
    value: '',
    available: ATTRIBUTES_VALIDATION_STATE.UNDEFINED,
    isValidating: false,
    error: null
  },
  name: {
    value: '',
    available: ATTRIBUTES_VALIDATION_STATE.UNDEFINED,
    isValidating: false,
    error: null
  },
  isProcessing: false,
  error: null
};

const actionTypes = {
  startOperation: START_CREATION_CLAN,
  updateFieldValue: UPDATE_CREATION_CLAN_FIELD_VALUE,
  startCheckAvailability: START_CHECK_AVAILABILITY_CLAN_CREATION,
  finishCheckAvailability: FINISH_CHECK_AVAILABILITY_CLAN_CREATION,
  updateError: ERROR_CREATION_CLAN,
  setInitialState: SET_INITIAL_STATE_CREATION_CLAN
};

export const clanCreate = clanNameTag(actionTypes, clanCreateInitialState);